import { useGetGuide, type GuideBaseInfoResponse } from "@/shared/server";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";
import { AsideBanner, GuideDetail, PieceBanner, Refund, Travel } from "../common";

export const Guide = () => {
    const { data } = useGetGuide<GuideBaseInfoResponse>();

    return data ? (
        <Box w="100%">
            <PieceBanner
                imgUrl={data.imgUrl}
                title={{
                    main: "Pension Guide",
                    sub: "펜션 종합이용안내",
                }}
            />
            <GuideDetail />
            <Refund />
            <AsideBanner isFullImg />
            <Travel />
        </Box>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
